<template>
  <generic-container
    v-bind:show_plus="true"
    icon="code"
    :title="$t('codes')"
    v-on:add="add_codes"
    :header_buttons="header_buttons"
  >
    <download-excel
      :data="missed_codes"
      v-show="missed_codes && missed_codes.length"
    >
      {{ $t("download") }}
      <img class="ui mini image" src="images/icons/download_excel.png" />
    </download-excel>
    <table class="ui celled selectable striped table" ref="table" width="100%">
      <thead>
        <tr>
          <th>{{ $t("code") }}</th>
          <th>{{ $t("status") }}</th>
          <th>{{ $t("create date") }}</th>
          <th>{{ $t("store") }}</th>
          <th>{{ $t("customer name") }}</th>
          <th>{{ $t("customer email") }}</th>
          <th>{{ $t("date") }}</th>
          <th>{{ $t("options") }}</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <upload-codes-modal ref="upload_codes_modal" />
  </generic-container>
</template>

<script>
import {
  error_toast,
  local_api,
  init_json_local_data_datables,
  enterprise_setup,
} from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import UploadCodesModal from "../upload_codes_modal/Index.vue";
import JsonExcel from "vue-json-excel";

export default {
  name: "BundleModalCodes",
  props: {},
  components: {
    downloadExcel: JsonExcel,
    GenericContainer,
    UploadCodesModal,
  },
  data() {
    return {
      bundle: {},
      codes: [],
      header_buttons: [
        { icon: "refresh", click: this.init },
        { icon: "download", click: this.download },
      ],
      missed_codes: [],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  filters: filters,
  methods: {
    add_codes() {
      let vm = this;
      vm.$refs.upload_codes_modal.show(vm.bundle);
    },
    init(bundle) {
      let vm = this;
      if (bundle) vm.bundle = bundle;
      local_api(vm, "post", "/nvidia_bundle/bundle/do-get-code-list", {
        bi: vm.bundle.bundle_id,
      })
        .then(function(r) {
          vm.codes = r;

          let columns = [
            {
              data: function(row) {
                // console.log(row);
                return row.code;
              },
            },
            {
              data: function(row) {
                if (row.status_code == "A") return vm.$t("available");
                else if (row.status_code == "T") return vm.$t("taken");
                else if (row.status_code == "C") return vm.$t("closed");
                else return row.status_code;
              },
            },
            {
              data: function(row) {
                return (
                  filters.formatDate(
                    row.create_date,
                    vm.enterprise_setup.simple_date_format,
                  ) || ""
                );
              },
            },
            {
              data: function(row) {
                if (row.nvb_code_request) {
                  return row.nvb_code_request.nvb_store.setup.name || "";
                } else {
                  return "";
                }
              },
            },
            {
              data: function(row) {
                if (row.nvb_code_request) {
                  return row.nvb_code_request.setup.customer_name || "";
                } else {
                  return "";
                }
              },
            },
            {
              data: function(row) {
                if (row.nvb_code_request) {
                  return row.nvb_code_request.setup.customer_email || "";
                } else {
                  return "";
                }
              },
            },
            {
              data: function(row) {
                if (row.nvb_code_request) {
                  return (
                    filters.formatDate(
                      row.nvb_code_request.create_date,
                      vm.enterprise_setup.simple_date_format,
                    ) || ""
                  );
                } else {
                  return "";
                }
              },
            },
            {
              data: function(row) {
                if (row.status_code != "A")
                  return `<div class="ui mini red icon button" onclick="window.dispatchEvent(new CustomEvent('free_code', { detail: { id: '${row.code_id}'}}))"><i class="trash icon"></i"></div>`;
                else return "";
              },
            },
          ];

          let onSelect = () => {};
          let onPageChanged = () => {};

          let onCreatedRow = (row, data) => {
            if (data.status_code == "T") window.jQuery(row).addClass("warning");
            else if (data.status_code == "C")
              window.jQuery(row).addClass("error");
            // console.log(row, data);
          };
          init_json_local_data_datables(
            vm,
            vm.$refs.table,
            r,
            columns,
            onSelect,
            onCreatedRow,
            onPageChanged,
          );
        })
        .catch(function(err) {
          error_toast(err);
        });
    },
    download() {
      let vm = this;
      local_api(vm, "post", "/nvidia_bundle/bundle/do-get-unused-code-list", {
        bi: vm.bundle.bundle_id,
      })
        .then(function(r) {
          vm.missed_codes = r;
        })
        .catch(function(err) {
          error_toast(err);
        });
    },
  },
  mounted() {
    // let vm = this;
    // vm.init();
  },
  created() {
    let vm = this;
    window.addEventListener(
      "free_code",
      function(e) {
        let id = e.detail.id;
        vm.$alertify.confirm(vm.$t("are you sure to free code?"), function() {
          local_api(vm, "post", "/nvidia_bundle/bundle/do-set-free", {
            u: id,
          })
            .then(() => {
              vm.init(vm.bundle);
            })
            .catch((err) => {
              error_toast(err);
            });
        });
      },
      false,
    );
  },
};
</script>
